import { react2angular } from 'react2angular';

import app from '../../../browser/addform/scripts/app';

import { withContext } from '../../utils/hoc/withContext';

import { AreaParts } from './AreaParts';

import { compose } from 'redux';

import { withProvider } from '../../redux';

app.component(
  'areaParts',
  react2angular(
    compose<any>(withContext, withProvider)(AreaParts),
    [
      'areaParts',
      'onAddBlock',
      'onRemoveBlock',
      'onChangeField',
      'invalidFields',
      'showAddButton',
      'onReset',
      'validateField',
      'onPhotoSelect',
      'partsLoadingStatus',
      'uploadErrors',
      'onPhotoRemove',
      'onPhotoRotate',
      'onPhotosMove',
    ],
    ['config'],
  ),
);
